module.exports = __webpack_public_path__ + "static/media/extra.31f8a7a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/FranzEliza/extra.png
// module id = 146
// module chunks = 0